import React, { FC, useState } from 'react'
import { IonContent, IonModal, IonFooter, IonToggle, IonButton } from '@ionic/react'
import { observer } from 'mobx-react'
import { productCenter, menuMobx, restaurantCenter, restaurantConfig, convertHmsToHm } from 'restaurant'
import i18n from 'i18next'
import { ddayjs, store } from '@dt/fe-utils'
import { useHistoryNew } from '@utils'
import { VersionBar, ModalHeader } from '@cps'
import './index.scss'

const DevelopModal: FC<any> = ({ reject, resolve }) => {
  const history = useHistoryNew()
  const switchSignal = (cfg: string) => {
    restaurantCenter.setState(cfg)
  }
  const [consoleList] = useState([
    {
      title: '营销控制输出',
      key: 'console.discount'
    },
    {
      title: '费用控制输出',
      key: 'console.fee'
    },
    {
      title: '支付方案输出',
      key: 'console.payplan'
    }
  ])
  const [otherList, setOtherList] = useState([
    {
      title: 'CN浏览器能打开',
      key: 'cn.openbrower',
      value: false
    }
  ])
  const handleSetOther = (key: string, value: boolean) => {
    const list = otherList.map(item => {
      if (item.key === key) {
        item.value = value
      }
      return item
    })
    setOtherList(list)
    store.set(key, value)
  }
  return (
    <IonModal
      cssClass='develop-modal tall-modal'
      isOpen
      swipeToClose
      onDidDismiss={reject}
    >
      <ModalHeader title='Hello' onClose={reject} />
      <IonContent>
        <div>
          <h4>菜单</h4>
          <div className='store-item'>
            <span>当前菜单</span>
            <span>begin:{convertHmsToHm(menuMobx.range.begin)};end:{convertHmsToHm(menuMobx.range.end)}</span>
          </div>
          {
            productCenter.menus.map((menu, index) => (
              <div key={menu.begin} className='store-item'>
                <span>菜单 {index + 1}</span>
                <span>begin:{convertHmsToHm(menu.begin)};end:{convertHmsToHm(menu.end)}</span>
              </div>
            ))
          }
          <div className='store-item'>
            <span>下一个刷新时间点</span>
            <span>{ddayjs(menuMobx.nextRefreshTime.valueOf()).format()}</span>
          </div>
          <h4>Event delay</h4>
          {
            restaurantCenter.getDelay().map(delay => {
              return (
                <div key={delay.handleId} className='store-item'>
                  <span>#{ddayjs(delay.trigger).format()}</span>
                  <span>{delay.event}</span>
                </div>
              )
            })
          }
          <h4>console 管理</h4>
          {
            consoleList.map(item => (
              <div key={item.key} className='store-item'>
                <div> {item.title}</div>
                <div>
                  <IonToggle checked={restaurantConfig.signal[item.key] || false} onClick={e => switchSignal(item.key)} />
                </div>
              </div>
            ))
          }
          <h4>显示模式</h4>
          <div className='store-item'>
            <IonButton onClick={() => {
              restaurantCenter.setConfig('displayMode', 'waterfall')
              reject()
            }}
            >瀑布流
            </IonButton>
            <IonButton onClick={() => {
              restaurantCenter.setConfig('displayMode', 'classic')
              reject()
            }}
            >经典
            </IonButton>
            <IonButton onClick={() => {
              restaurantCenter.setConfig('displayMode', 'waterfallCategory')
              reject()
            }}
            >经典大图
            </IonButton>
          </div>
          <h4>其它管理</h4>
          {
            otherList.map(item => (
              <div key={item.key} className='store-item'>
                <div> {item.title}</div>
                <div>
                  <IonToggle checked={item.value} onClick={e => handleSetOther(item.key, !item.value)} />
                </div>
              </div>
            ))
          }
          <VersionBar />
        </div>
      </IonContent>
      <IonFooter>
        <button onClick={() => resolve()}>{i18n.t('common.ok')}</button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(DevelopModal)
